// extracted by mini-css-extract-plugin
module.exports = {"skipContainer":"VideoSkips_skipContainer__OKInm"};